import { computed, toValue } from "vue";
import { unrefElement } from "@vueuse/core";
export function useDrawerGuards(args) {
  const { elRef, absDirectionX, absDirectionY, position, activeSnapPoint } = args;
  const hasCursor = computed(() => {
    return typeof window !== "undefined" && matchMedia("(hover: hover)").matches;
  });
  const canSnap = computed(() => {
    return toValue(activeSnapPoint) !== 1 && !!toValue(activeSnapPoint);
  });
  function canDrag(el) {
    let element = el;
    if (hasCursor.value) {
      return true;
    }
    if (canSnap.value) {
      return true;
    }
    while (element) {
      if (element === unrefElement(elRef)) {
        return true;
      }
      switch (position) {
        case "bottom":
          if (element.scrollHeight > element.clientHeight) {
            if (element.scrollTop > 0) {
              return false;
            }
            if (toValue(absDirectionY) === "with") {
              return false;
            }
            if (!toValue(absDirectionY)) {
              return false;
            }
          }
          break;
        case "top":
          if (element.scrollHeight > element.clientHeight) {
            const maxScroll = element.scrollHeight - element.clientHeight;
            if (element.scrollTop < maxScroll) {
              return false;
            }
            if (toValue(absDirectionY) === "with") {
              return false;
            }
            if (!toValue(absDirectionY)) {
              return false;
            }
          }
          break;
        case "right":
          if (element.scrollWidth > element.clientWidth) {
            if (element.scrollLeft > 0) {
              return false;
            }
            if (toValue(absDirectionX) === "with") {
              return false;
            }
            if (!toValue(absDirectionX)) {
              return false;
            }
          }
          break;
        case "left":
          if (element.scrollWidth > element.clientWidth) {
            const maxScroll = element.scrollWidth - element.clientWidth;
            if (element.scrollLeft < maxScroll) {
              return false;
            }
            if (toValue(absDirectionX) === "with") {
              return false;
            }
            if (!toValue(absDirectionX)) {
              return false;
            }
          }
          break;
      }
      element = element.parentNode;
    }
    return true;
  }
  function canInterpolate(el) {
    let element = el;
    if (hasCursor.value) {
      return true;
    }
    while (element) {
      switch (position) {
        case "bottom":
        case "top":
          if (element.scrollHeight > element.clientHeight) {
            return false;
          }
          break;
        case "left":
        case "right":
          if (element.scrollWidth > element.clientWidth) {
            return false;
          }
          break;
      }
      if (element === unrefElement(elRef)) {
        return true;
      }
      element = element.parentNode;
    }
  }
  function lockScroll(el) {
    let element = el;
    if (hasCursor.value && !canSnap.value) {
      return void 0;
    }
    while (element) {
      if (element === unrefElement(elRef)) {
        return void 0;
      }
      switch (position) {
        case "bottom":
          if (element.scrollHeight > element.clientHeight) {
            if (element.scrollTop === 0 || canSnap.value) {
              if (toValue(absDirectionY) === "against") {
                return element;
              }
            }
          }
          break;
        case "top":
          if (element.scrollHeight > element.clientHeight) {
            const maxScroll = element.scrollHeight - element.clientHeight;
            if (element.scrollTop === maxScroll || canSnap.value) {
              if (toValue(absDirectionY) === "against") {
                return element;
              }
            }
          }
          break;
        case "right":
          if (element.scrollWidth > element.clientWidth) {
            if (element.scrollLeft === 0 || canSnap.value) {
              if (toValue(absDirectionX) === "against") {
                return element;
              }
            }
          }
          break;
        case "left":
          if (element.scrollWidth > element.clientWidth) {
            const maxScroll = element.scrollWidth - element.clientWidth;
            if (element.scrollLeft === maxScroll || canSnap.value) {
              if (toValue(absDirectionX) === "against") {
                return element;
              }
            }
          }
          break;
      }
      element = element.parentNode;
    }
  }
  return {
    canDrag,
    canInterpolate,
    lockScroll
  };
}
